/* File to store constants used across application */
export const BLANK_HTML: string = '<html><head></head><body><p></p></body></html>';

export enum WEBFORM_TEXT {
  SUBMIT = 'Submit',
  FORM_INSTRUCTION = 'Please complete this form',
  LOADING = 'Loading...',
  DEFAULT_INCIDENT_NAME = 'Incident Web Form',
  CAPTCHA_LABEL = 'Captcha *',
  NAVIGATION_PROMPT = 'Changes you made may not be saved.'
}

export const GROWL_MSG_SUBMITTED: string = 'Data was saved.';

// Used for new events as LMX Suggestions require an incident ID in request
export const TEMP_INCIDENT_ID: number = 0;
